export default {
  title: 'Relatório do Modelo',
  kpiLabel: 'KPI',
  aboutOptimalZones: 'Sobre as Zonas Ótimas',
  zone1Label: 'Zona 1:',
  zone1Description: 'Esta faixa geralmente deve ser evitada, pois está abaixo do Limite Mínimo de Gasto, resultando em contribuições insignificantes. Qualquer dólar gasto nesta zona é essencialmente desperdiçado.',
  zone2Label: 'Zona 2:',
  zone2Description: 'Nesta faixa, os dólares gastos começam a mostrar uma contribuição marginal pequena mas de rápido crescimento. Tipicamente, pequenos aumentos no gasto produzem altos ganhos em contribuição marginal, até o ponto onde a Contribuição Marginal Máxima é alcançada (marcando o fim desta zona).',
  zone3Label: 'Zona 3:',
  zone3Description: 'Esta faixa, junto com a próxima, é geralmente considerada "ótima". À medida que o gasto aumenta nesta faixa, a contribuição marginal de cada dólar adicional gasto diminui gradualmente, embora o Retorno sobre Investimento em Publicidade (ROAS) para cada dólar continue crescendo. Isso significa que, embora a contribuição marginal fique menor, ainda é eficiente continuar gastando porque a contribuição total cresce. Isso continua até o ponto onde o ROAS Máximo é alcançado (o fim desta zona).',
  zone4Label: 'Zona 4:',
  zone4Description: 'Esta faixa, junto com a anterior, é geralmente considerada "ótima". No entanto, diferente da Zona 3, à medida que o gasto aumenta nesta faixa, o ROAS diminui gradualmente, tornando o gasto adicional cada vez menos eficiente. Isso ocorre porque a contribuição de cada dólar diminui em comparação com a quantia sendo gasta. Esta tendência continua até alcançar o ponto de Retornos Decrescentes, que representa o nível máximo de gasto recomendado. Além deste ponto, cada dólar adicional gasto produz retornos insignificantes e é essencialmente desperdiçado.',
  zone5Label: 'Zona 5:',
  zone5Description: 'Similar à Zona 1, esta faixa geralmente deve ser evitada, pois representa gastar além do que é eficiente. Nesta zona, a contribuição de cada dólar adicional é tão pequena que é essencialmente um desperdício de recursos.',
  ok: 'Ok',
  averageCpiTitle: 'CPI Médio',
  averageCpiDescription: 'Digite o Custo Médio Por Impressão (MXN) para cada canal de mídia:',
  cancel: 'Cancelar',
  save: 'Salvar',
  shareModelReport: 'Compartilhar Relatório do Modelo',
  enableSharing: 'Habilitar compartilhamento para este relatório do modelo',
  shareLinkLabel: 'Link para Compartilhar',
  close: 'Fechar',
  linkCopied: 'Link copiado para a área de transferência!',
  manageAccess: 'Gerenciar Acesso',
  spendLabel: 'Gasto',
  totalSpendInfo: 'Gasto total em mídia durante o período do relatório.',
  totalSalesInfo: 'Total de {kpiName} reportado durante o período do relatório.',
  fullPeriodTab: 'Período Completo',
  monthlyDetailTab: 'Detalhe Mensal',
  segmentsDetailTab: 'Detalhe por Segmentos',
  adminTab: 'Admin',
  modelFit: 'Ajuste do Modelo',
  modelFitInfo: 'Comparação do KPI real que está sendo modelado vs. os valores previstos do modelo. Espera-se que a curva prevista siga de perto os valores reais que estão sendo modelados.',
  mapeLabel: 'MAPE (%)',
  mapeInfo: 'MAPE significa "Erro Percentual Absoluto Médio", e é uma medida de quão preciso é o modelo. Um valor baixo de MAPE indica uma pequena diferença, em média, entre o KPI real vs. os valores previstos do modelo.',
  raeLabel: 'RAE (%)',
  raeInfo: 'RAE significa "Erro Absoluto Relativo", e é uma medida de quão preciso é o modelo. Diferente do MAPE, o RAE acumula o erro absoluto entre o KPI real vs. os valores previstos do modelo ao longo de todo o período relativo à variação do KPI vs. a média do KPI no mesmo período. Um valor baixo de RAE indica uma pequena diferença, no total e relativa à variabilidade do KPI, entre o KPI real vs. os valores previstos do modelo.',
  correlationLabel: 'Correlação (%)',
  correlationInfo: 'Medida de quão correlacionado o Incremento de Marketing está com o KPI. Valores altos de correlação são indicativos de que o marketing é efetivamente um impulsionador mensurável do KPI, o que por sua vez resulta em modelos mais robustos.',
  salesDecompositionTitle: 'Decomposição de {kpiName}',
  salesDecompositionInfo: 'Decomposição do KPI entre os diferentes componentes do modelo. Embora estes variem de modelo para modelo, os seguintes são os mais frequentes:',
  baseLabel: 'Base',
  baseDescription: 'é a porção de {kpiName} que não pode ser atribuída diretamente às diferentes ações de marketing que ocorreram durante cada período, mas sim é o resultado a longo prazo de atividades de marketing passadas.',
  mediaLabel: 'Mídia',
  mediaDescription: 'é a porção de {kpiName} que é atribuída especificamente ao gasto em mídia que ocorreu durante o período.',
  seasonalityLabel: 'Sazonalidade',
  seasonalityDescription: 'representa {kpiName} que são simplesmente atribuíveis a fatores cíclicos que se repetem no tempo, assim como outros eventos únicos que têm um efeito direto sobre {kpiName}.',
  noiseLabel: 'Ruído',
  noiseDescription: 'é a pequena porção de {kpiName} que não pode ser atribuída a nenhuma das variáveis no modelo, nem tem um comportamento algo estruturado e previsível como a base, portanto se torna ruído no modelo.',
  mediaMixTitle: 'Mix de Mídia',
  mediaAttributedDecomposition: 'Decomposição de {kpiName} Atribuída à Mídia',
  mediaAttributedDecompositionInfo: 'Decomposição detalhada do Componente de Mídia em seus veículos individuais (ou grupos deles).',
  saturationCurves: 'Curvas de Saturação',
  generalViewTab: 'Visão Geral',
  optimalZonesTab: 'Zonas Ótimas',
  spendUnit: 'Unidade de Gasto',
  editAverageCpi: 'Editar Custo Médio Por Impressão',
  showHistoricalDatapoints: 'Mostrar pontos de dados históricos de gasto',
  exportCurves: 'Exportar curvas',
  decayCurves: 'Curvas de Decaimento',
  impactPercent: 'Impacto (%/100)',
  periods: 'Períodos',
  months: 'Meses',
  weeks: 'Semanas',
  seasonalityEffects: 'Efeitos de Sazonalidade',
  effectLabel: 'Efeito',
  mediaSpendTitle: 'Gasto em Mídia',
  mediaMix: 'Mix de Mídia',
  spendPercent: '% de Gasto',
  salesDecompositionByPeriod: 'Decomposição de {kpiName} por Período',
  mediaAttributionByPeriod: 'Atribuição de Mídia por Período',
  pricingEffect: 'Efeito de Preço',
  priceValue: 'Valor do Preço',
  priceEffect: 'Efeito do Preço',
  distributionEffect: 'Efeito de Distribuição',
  distributionValue: 'Valor de Distribuição',
  quarterlyAverageTotalRoas: 'ROAS Total Médio Trimestral',
  quarterlyAverageRoasByMedia: 'ROAS Médio Trimestral por Mídia',
  segmentsContributionInfo: 'Contribuição estimada de {kpiName} por segmento demográfico',
  rawReportOutput: 'Saída RAW do Relatório',
  customization: 'Personalização',
  injectChanges: 'Injetar alterações',
  buildingModelReport: 'Construindo Relatório do Modelo...',
  prediction: 'Previsão',
  real: 'Real'
}
